import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import * as classnames from 'classnames';

import User from '../User';
import HeaderNavbar from './Navbar';
import HeaderBurger from './Burger';
import bg from '../../img/header-bg.png';

import './styles.scss';

const Header = () => {
	const [isActive, setIsActive] = useState(false);
	const user = useSelector((state) => state.firebase.profile);	

	const handleActiveBurget = (active) => {
		setIsActive(active)
	};

	return (
		<div className="header__wrapper">
			<header 
				className={
					classnames('header', {
						'header--active': isActive,
					})
				}
			>
				<img className="header__img" src={bg} alt="background-header"/>
				<div className="container">
					<div className="header__content">
						<div className="header__user">
							<Link to="/">
								<User user={user} isCurrent isLight/>
							</Link>
						</div>
						<HeaderNavbar />
						<div className="margin-left-auto">
							<HeaderBurger active={handleActiveBurget}/>
						</div>
					</div>
				</div>
			</header>
		</div>
	);
};

export default Header;
